import { Component, EventEmitter, Input, OnInit, Output, ViewContainerRef } from '@angular/core';
import { AppMetadataHandler, PolicyDO, UserInfoService } from 'app';
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO
} from 'app';
import { MetadataService } from '../../../BaseFramework/core/http/metadata.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DataTransformService } from 'app/ViewModules/shared-services';
import { NewBusinessAppSettings } from 'app/ViewModules/Newbusiness/newbusiness-configs';
import { environment } from 'environments/environment';
import configData from './receipting.component.json'
import { NzMessageService } from 'ng-zorro-antd/message';
import moment from 'moment';



interface receiptDO {
  "parentObject": null,
    "versionId": null,
    "shareByRegionalOfc": null,
    "accountTypeCd": null,
    "checkNo": null,
    "accountHolderName": null,
    "accountNum": null,
    "ifsc": null,
    "micr": null,
    "bankName": null,
    "bankBranchName": null,
    "clientId": null,
    "paymentMethodCd": null,
    "clientRefGuid": null,
    "payoutKey": null,
    "upiId": null,
    "mmid": null,
    "cardNum": null,
    "cardName": null,
    "dueDt": null,
    "transactionDt":null,
    "dueAmt": null,
    "paymentStatusCd": null,
    "amount":null,
    "internalNotes": null,
    "externalNotes": null,
    "paymentAvenueCd": null,
    "receiptNum": null,
    "receiptStatusCd": "RECEIPTGENERATED",
    "installmentTypeCd": null,
    "cashDenominationList": [],
    "objectName": "PolicyReceiptDO",
    "baseAdditionalFields": null,
    "referenceNum": null 
}
class SearchAPIMetaDataDO {
  key: any;
  keyDescription: any;
  valueInputType: any;
  lookupName: any;
  lookup: any;
  enable: true;
  isMandatory: Boolean;
}
@Component({
  selector: 'app-receipting',
  templateUrl: './receipting.component.html',
  styleUrls: ['./receipting.component.scss']
})
export class ReceiptingComponent implements OnInit {
  getSearchCriteriaListArgument : string= 'searchReceipts'
  constructor(
    private viewContainerRef: ViewContainerRef,
    public appMetadataHandler: AppMetadataHandler,
    private commonUtilty: CommonUtilty,    
    private metadataService: MetadataService,    
    private fb: FormBuilder,    
    private interactService: InteractService,
    private validationUtilService: ValidationUtilService,
    public dataTransformService: DataTransformService,
    private apiRequestService: ApiRequestService,
    public newBusinessAppSettings: NewBusinessAppSettings,
    public userInfoService: UserInfoService,
    public message: NzMessageService) { }

  ngOnInit() {
    if(!this.configData){
      this.getConfigDataAndInitialize();
    }
    this.getSearchCriteriaList();
    this.extractPolictSummaryDataForReceipting();
    this.initializeReceiptDataForm(this._IO)
    this.subscribeToParentEvent();
    this.lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind);
    if (this.commonUtilty.isArrayIterable(environment['lob'])) {
      environment['lob'].forEach(lob => {
        this.tabArray = configData.LobBasedSearchArray.filter(item => item.productFamilyCd === lob)
      });
    }
    else
      this.tabArray = configData.LobBasedSearchArray;
    this.metadataService.getSearchCriteriaList(this.getSearchCriteriaListArgument).subscribe(resp => {
      this.CRITERIALOOKUP = this.commonUtilty.deepCopy(resp)
    });

    // if(this.configData && this.configData.ComponentMetaDataConfiguration && this.configData.ComponentMetaDataConfiguration.ReceiptingComponentNB && this.configData.ComponentMetaDataConfiguration.ReceiptingComponentNB.gridConfig){
    //   let gridMetaData = this.configData.ComponentMetaDataConfiguration.ReceiptingComponentNB.gridConfig
    //   if(this._IO && this._IO.proposalDO){
    //     gridMetaData.fieldMapping = 'proposalDO-proposalReceipts'
    //     gridMetaData.fieldKey = 'proposalReceipts'
    //   }else if(this._IO && this._IO.caseDO){
    //     gridMetaData.fieldMapping = 'caseDO-caseReceipts'
    //     gridMetaData.fieldKey = 'caseReceipts'
    //   }else{
    //     gridMetaData.fieldMapping = 'caseDO-caseReceipts'
    //     gridMetaData.fieldKey = 'caseReceipts'
    //   }
     
    // }
  


    // this.tableInput = this.dataTransformService.policySearchResult;
    if(Array.isArray(this.dataTransformService.policySearchResult) && this.dataTransformService.policySearchResult.length) this.showNoData = true
  }
  showNoData = false;
  tableInput
  ngOnDestroy(): void {
    this.dataTransformService.policySearchResult = null;  
  }

  _currentComponentName = 'ReceiptingComponent';
  @Input() viewFromTab = false;
  @Input() configData;
  @Input() transactionState;
  @Output() componentOutput = new EventEmitter<any>();
  @Input() payloadInEdit
  _IO = null;
  public DO = null;
  @Input()
  set IO(value: any) {
    if (value) {
      this._IO = this.ServerToUITransform(value);
      this.DO = this.commonUtilty.getDO(this._IO);
      this.getLatestFiveProposals(this.LOB);
      this.extractPolictSummaryDataForReceipting();
    }

  };

  receiptDataForm: FormGroup;
  RECEIPTDATAFORMNAME = "receiptDataForm";
  LOB : string = 'HEALTH'

  payloadData={}
  public CRITERIALOOKUP = [];
  paymentLookup = [];
  /*transactionDate;
  paymentMode;
  amount;
  paymentAvenue;
  upiId;
  UTRNumber= null;
  internalNotes;
  externalNotes;*/
  payloadForDenomination = [];

  lookupsToBind = ['paymentMethodCd','PaymentAvenueCd'];
  lookup$;

  configPath = "/configs/health-nbu-transaction.json"
  getConfigDataAndInitialize() {
    // get configData from Assets
    this.apiRequestService.get(this.configPath, null, true).subscribe(response => {
      this.configData = this.commonUtilty.deepCopy(response);
    })
  }


  fetchSearchResult($event) {
    if ($event && !$event.reset) {
      if ($event && $event.results) {
        this.dataTransformService.policySearchResult = $event.results;
        console.log(this.dataTransformService.policySearchResult)
      }
      else this.dataTransformService.policySearchResult = []
    }
    else this.getLatestFiveProposals(this.LOB);
  }

  
  isRequired(control){}

  getSearchCriteriaList() {
    this.metadataService.fetchAPIMetaData('searchReceipts')
      .subscribe(jsonResp => {
        if (jsonResp && typeof jsonResp === typeof []) {
          jsonResp.forEach(criteria => {
            let searchCriteriaDO = new SearchAPIMetaDataDO();
            searchCriteriaDO.key = criteria.attributeName;
            searchCriteriaDO.keyDescription = criteria.description;
            searchCriteriaDO.valueInputType = criteria.attributeDataTypeCd;
            searchCriteriaDO.lookupName = criteria.attributeLookupCd;
            searchCriteriaDO.lookup = [];
            searchCriteriaDO.enable = true;
            searchCriteriaDO.isMandatory = criteria.mandatoryFl == 'YES' ? true : false;
            this.CRITERIALOOKUP.push(searchCriteriaDO)
          })
        }
      })
  }

  _BaseEmitHandler(data, componentName) {

  }

  searchedPolicyData = [];
  extractPolictSummaryDataForReceipting(){
    let DO = this.commonUtilty.getDOName(this._IO);
    let clientList = DO == 'caseDO' ? 'caseClients' : 'proposalClients';
    if(this._IO && this._IO[DO]){
      let tranObj = {};
      tranObj["proposalNum"] = this._IO[DO]['proposalNum'];
      tranObj["currencyCd"] = this._IO[DO]['currencyCd'];
      this.currencyOptions.prefix = this._IO[DO]['currencyCd'] ? this._IO[DO]['currencyCd'] : this.currencyOptions.prefix
      tranObj["proposer"] = this.getProposerName(this._IO[DO], clientList);
      tranObj["dueDate"] = this._IO[DO]['dueDt'];
      //tranObj["transactionDt"] = this._IO[DO]['proposalNum'];
      tranObj["dueAmount"] = this._IO[DO]['policyInstallmentList'] && this.commonUtilty.isArrayIterable(this._IO[DO]['policyInstallmentList']) ? this._IO[DO]['policyInstallmentList'][0]['installmentAmt'] : 0;
      tranObj["paymentStatus"] = this._IO[DO]['premiumStatusCd'];
      this.searchedPolicyData.push(tranObj);
      }
    this.dataTransformService.policySearchResult = this.commonUtilty.deepCopy(this.searchedPolicyData)
    this.dataTransformService.policySearchResult = this.removeDuplicates(this.dataTransformService.policySearchResult, 'proposalNum');
    console.log(this.dataTransformService.policySearchResult);
  }
  removeDuplicates(array, property) {
    const uniqueMap = new Map();
    array.forEach(item => {
      uniqueMap.set(item[property], item);
    });
    return Array.from(uniqueMap.values());
  }

  getProposerName(data, clientList){
    let ownerId = null;
    let owner = {};
    if(data && this.commonUtilty.isArrayIterable(data[clientList])){
      data[clientList].forEach(item=>{
        if(item.roleCd == 'OWNER' && item.clientRefGuid){
          ownerId = item.clientRefGuid;
        }
      })
      // ownerId = data[clientList].find(client => client.roleCd == 'OWNER').clientRefGuid;
    }
    if(ownerId && this._IO && this.commonUtilty.isArrayIterable(this._IO['clientDOs'])){
      owner = this._IO['clientDOs'].find(client => (client !== null && client.guid == ownerId));
    }
    return owner ? owner['name'] : null;
  }
  initializeReceiptDataForm(data){
    let DO = this.commonUtilty.getDOName(data);
    let receiptDO = DO == 'caseDO' ? 'caseReceiptDOs' : 'proposalReceipts';
    let payload = {};
    if(data && data[DO][receiptDO] && data[DO][receiptDO].find(e => true)){
      payload = data[DO][receiptDO].find(e => true) || {};
    }else{
      payload = {};
    }
    
    this.receiptDataForm = this.fb.group({
      transactionDt: this.validationUtilService.setValidationsForFormControl('transactionDt', this.RECEIPTDATAFORMNAME, payload['transactionDt']),
      paymentMethodCd: this.validationUtilService.setValidationsForFormControl('paymentMethodCd', this.RECEIPTDATAFORMNAME, payload['paymentMethodCd']),
      paymentAvenueCd: this.validationUtilService.setValidationsForFormControl('paymentAvenueCd', this.RECEIPTDATAFORMNAME, payload['paymentAvenueCd']), 
      amount: this.validationUtilService.setValidationsForFormControl('amount', this.RECEIPTDATAFORMNAME, payload['amount']), 
      upiId: this.validationUtilService.setValidationsForFormControl('upiId', this.RECEIPTDATAFORMNAME, payload['upiId']), 
      payoutKey: this.validationUtilService.setValidationsForFormControl('payoutKey', this.RECEIPTDATAFORMNAME, payload['payoutKey']), 
      internalNotes: this.validationUtilService.setValidationsForFormControl('internalNotes', this.RECEIPTDATAFORMNAME, payload['internalNotes']), 
      externalNotes: this.validationUtilService.setValidationsForFormControl('externalNotes', this.RECEIPTDATAFORMNAME, payload['externalNotes']),
    });
  }

  parentEvent$;
  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      //let validationResult = this.validateOutput(this.claimsBankDetailsForm)
      //if (!validationResult.isInvalid)
        this.EmitComponentOutput(this.receiptDataForm.value)
      /*else {
        this.EmitComponentOutput(validationResult)
      }*/
    })
  }
  getDateString(rawDate) {
    let dateString;
  
    if (rawDate != null && Array.isArray(rawDate)) {
      const [year, month, day] = rawDate;
      const momentDate = moment({ year, month: month - 1, day });
      const normalizedDate = momentDate.add(1, 'day');
      dateString = normalizedDate.format(this.appMetadataHandler.GLOBAL_DATE_FORMAT_MOMENT);
    } else {
      dateString = 'N/A';
    }
    return dateString;
  }
  
  

  UItoServerTransform(payload, response) {
    let DO = this.commonUtilty.getDOName(payload);
    let receiptDO = DO == 'caseDO' ? 'caseReceipts' : 'proposalReceipts';
    if(response.componentData['transactionDt']) response.componentData['transactionDt'] = this.commonUtilty.UIDOtoServerDODate(response.componentData['transactionDt']);
    payload[DO][receiptDO] = [response.componentData];
    return payload;
  }

  ServerToUITransform(payload){
    let DO = this.commonUtilty.getDOName(payload);
    let receiptDO = DO == 'caseDO' ? 'caseReceipts' : 'proposalReceipts';
    if( payload[DO] && this.commonUtilty.isArrayIterable(payload[DO][receiptDO])){
      payload[DO][receiptDO].forEach(element => {
        element['transactionDt'] = this.commonUtilty.serverDOtoUIDODate(element['transactionDt']);
      });
    }
    return payload;
  }

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput, this.UItoServerTransform)
  }
  getParentComponent(): Component {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
 } catch{}
  }
  getParentComponentName(): string {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
 } catch{}
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }
  public tabArray = [];
  public productFamilyCd = null;
  itemsPerPage: any = 5;
  currentPage: any = 0;
  searchURL = "searchInstallments"
  getLatestFiveProposals(productFamilyCd) {
    this.productFamilyCd = productFamilyCd
    this.newBusinessAppSettings.APPCONSTANTS.productFamilyCd = this.productFamilyCd;
    var payload = {}
    payload["page"] = this.currentPage;
    payload["size"] = this.itemsPerPage;
    payload["searchCriteriaList"] = []
    var criteriaItem1 = {}
    var criteriaItem2 = {}
    let userId = null
    let proposalNum = null
    proposalNum = this.DO.proposalNum;
    userId = this.userInfoService.getUserId();
    criteriaItem1 = {}
    criteriaItem1["paramName"] = 'proposalNum'
    criteriaItem1["paramValue"] = proposalNum
    payload["searchCriteriaList"].push(criteriaItem1)
    this.apiRequestService.postCallWithAPIMapper(this.searchURL, payload).subscribe(data => {
      this.dataTransformService.policySearchResult = data.results;
    });
  }

  currencyPrefix = this.appMetadataHandler.baseCurrencyPREFIX;
  currencyOptions = {
    prefix: this.appMetadataHandler.baseCurrencyPREFIX,
    thousands: this.appMetadataHandler.THOUSANDS_SEPARATOR,
    decimal: this.appMetadataHandler.DECIMAL_SEPARATOR,
    align: this.appMetadataHandler.currencyAlignment
  }
  // getLatestFiveProposals(productFamilyCd) {
  //   this.productFamilyCd = productFamilyCd;
  //   this.newBusinessAppSettings.APPCONSTANTS.productFamilyCd = this.productFamilyCd;
  //   var payload = {};
  //   payload['page'] = this.currentPage;
  //   payload['size'] = this.itemsPerPage;
  //   payload['searchCriteriaList'] = [];
  //   var criteriaItem1 = {};
  //   let userId = this.userInfoService.getUserId();
  //   criteriaItem1['paramName'] = 'criteriaUser';
  //   criteriaItem1['paramValue'] = userId;
  //   payload['searchCriteriaList'].push(criteriaItem1);
  
  //   this.apiRequestService.postCallWithAPIMapper(this.searchURL, payload).subscribe((data) => {
  //     // Filter results to include only the first installment or if installment date is <= today's date
  //     this.dataTransformService.policySearchResult = data.results.filter((result) => {
  //       // Assuming the installment date is available in result.installmentDate
  //       let installmentDate = result.installmentDt;
  //       return (
  //         installmentDate &&
  //         Array.isArray(installmentDate) &&
  //         moment(installmentDate).isSameOrBefore(moment(), 'day')
  //       );
  //     });
  //   });
  // }
  refreshReceiptDataForm: boolean = true
  private _toggleReceiptDataForm() {
    this.refreshReceiptDataForm = false;
    setTimeout(() => { this.refreshReceiptDataForm = true; }, 300);
}
  proposalIO : any
  selectReceipt(guid){
    let pathVariables = [];
    pathVariables.push(guid || null);

    let url = 'policyFetchByGuid'
     this.apiRequestService.getCallWithAPIMapper(url, null, null, pathVariables).subscribe(res=>{
    
    // let url = `policyFetchByGuid/${guid}`
    //  this.apiRequestService.getCallWithAPIMapper(url).subscribe(res=>{
        this.proposalIO = res
      if(res && res.proposalDO && res.proposalDO.policyInstallmentList && this.commonUtilty.isArrayIterable(res.proposalDO.policyInstallmentList) && res.proposalDO.policyInstallmentList[0])
      {
        if (this.receiptDataForm && this.receiptDataForm.controls && res.proposalDO.policyInstallmentList[0].pendingAmt ){
        this.receiptDataForm.controls['amount'].setValue(res.proposalDO.policyInstallmentList[0].pendingAmt)
        }
        if (res && res.proposalDO && res.proposalDO.proposalReceipts && this.commonUtilty.isArrayIterable(res.proposalDO.proposalReceipts) && res.proposalDO.proposalReceipts[0]) {
          if (this.receiptDataForm && this.receiptDataForm.controls && res.proposalDO.proposalReceipts[0].paymentMethodCd) {
            // this.receiptDataForm.controls['transactionDt'].setValue(res.proposalDO.proposalReceipts[0].transactionDt);
            this.receiptDataForm.controls['paymentMethodCd'].setValue(res.proposalDO.proposalReceipts[0].paymentMethodCd)
          }
        }
        // && res.proposalDO.proposalReceipts[0].transactionDt 
        // this._toggleReceiptDataForm()
      }
    })
  }
  saveReceipt(){
    let url = `proposalSave`
      // "amount" : (this.receiptDataForm.controls.amount.value),
      // "paymentMethodCd" : (this.receiptDataForm.controls.paymentMethodCd.value),
      // "transactionDt" : (this.receiptDataForm.controls.transactionDt.value),
      let receipt: receiptDO = {  
        "parentObject": null,
        "versionId": null,
        "shareByRegionalOfc": null,
        "accountTypeCd": null,
        "checkNo": null,
        "accountHolderName": null,
        "accountNum": null,
        "ifsc": null,
        "micr": null,
        "bankName": null,
        "bankBranchName": null,
        "clientId": null,
        "paymentMethodCd": (this.receiptDataForm.controls.paymentMethodCd.value),
        "clientRefGuid": null,
        "payoutKey": null,
        "upiId": null,
        "mmid": null,
        "cardNum": null,
        "cardName": null,
        "dueDt": null,
        "transactionDt":(this.receiptDataForm.controls.transactionDt.value),
        "dueAmt": null,
        "paymentStatusCd": null,
        "amount":(this.receiptDataForm.controls.amount.value),
        "internalNotes": (this.receiptDataForm.controls.internalNotes.value),
        "externalNotes": (this.receiptDataForm.controls.externalNotes.value),
        "paymentAvenueCd": null,
        "receiptNum": null,
        "receiptStatusCd": "RECEIPTGENERATED",
        "installmentTypeCd": null,
        "cashDenominationList": [],
        "objectName": "PolicyReceiptDO",
        "baseAdditionalFields": null,
        "referenceNum": null
    }
    
    if (this.receiptDataForm && this.receiptDataForm.controls.amount) {
      // this.proposalIO.proposalDO.proposalReceipts[0].amount = (this.receiptDataForm.controls.amount.value);
      // this.proposalIO.proposalDO.proposalReceipts[0].paymentMethodCd = (this.receiptDataForm.controls.paymentMethodCd.value);
      // this.proposalIO.proposalDO.proposalReceipts[0].transactionDt = (this.receiptDataForm.controls.transactionDt.value)
      // this.proposalIO.proposalDO.proposalReceipts.push(recepTDetails)
      this.proposalIO.proposalDO.proposalReceipts  = this.commonUtilty.uniquePushInArray(this.proposalIO.proposalDO.proposalReceipts , receipt,'guid')
    }
    this.message.loading('Saving', { nzDuration: 10000 });
    this.apiRequestService.postCallWithAPIMapper(url, this.proposalIO).subscribe(res => {
      if (res) {
        this.message.success(`Saved`, { nzDuration: 4000 })
      }
    })
  }

  submitReceipt(){
    let url = `policySubmit`
    this.message.loading('Submitting', { nzDuration: 10000 });
    this.apiRequestService.postCallWithAPIMapper(url,this.proposalIO).subscribe(res=>{
      if(res){
        this.message.success(`Submitted`, { nzDuration: 4000 })
      }
    })
  }

  getInstallmentDate(date) {
  let dateString;
  if (date != null) {
    if (Array.isArray(date)) {
      let [year, month, day] = date;
      let momentDate = moment({ year, month: month - 1, day });

      if (momentDate.isSameOrBefore(moment(), 'day')) {
        dateString = momentDate.format(this.appMetadataHandler.GLOBAL_DATE_FORMAT_MOMENT);
      } else {
        dateString = '-';
      }
    } else {
      dateString = '-';
    }
  } else {
    dateString = '-';
  }
  return dateString;
}

}

  
  

